import React, { useEffect } from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { TOGGLE_GLOBAL_TOAST } from '../../store/actions/action-types';
import { useDispatchToProps, useStateToProps } from '../../store/actions/actions';

function ToastNotifier() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const toggleGlobalToast = useDispatchToProps(TOGGLE_GLOBAL_TOAST);
  const { globalToast } = useStateToProps((state) => ({
    globalToast: state.global.globalToast,
  }));

  useEffect(() => {
    if (!globalToast?.visibility || !globalToast?.label) {
      return;
    }

    const { type = 'error', label, timeout, traceId } = globalToast;
    const effectiveTimeout = traceId ? 15000 : timeout;
    const snackbarMessage = traceId ? `${label} ${traceId}` : label;

    enqueueSnackbar(snackbarMessage, {
      variant: type,
      autoHideDuration: effectiveTimeout,
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
      content: (snackKey) => (
        <Alert
          severity={type}
          variant="filled"
          onClose={() => closeSnackbar(snackKey)}
          sx={{
            width: '100%',
            color: '#fff',
            alignItems: 'flex-start',
            alignContent: 'flex-start',

            '& .MuiAlert-icon, & .MuiAlert-action': {
              alignItems: 'flex-start',
              pt: '3px',
            },
          }}
        >
          <Box>
            {label}
            {traceId && (
              <Box sx={{ mt: '5px', fontSize: '0.75rem', opacity: 0.8 }}>Trace ID: {traceId}</Box>
            )}
          </Box>
        </Alert>
      ),
    });

    toggleGlobalToast({
      visibility: false,
      label: '',
      type: 'error',
      traceId: undefined,
    });
  }, [closeSnackbar, enqueueSnackbar, globalToast, toggleGlobalToast]);

  return null;
}

function GlobalToast() {
  return (
    <SnackbarProvider maxSnack={10} preventDuplicate dense>
      <ToastNotifier />
    </SnackbarProvider>
  );
}

export default GlobalToast;
